export const shortenTransactionId = (blockchainTransactionId: string): string =>
	`${blockchainTransactionId.substring(0, 6)}...${blockchainTransactionId.substring(
		blockchainTransactionId.length - 8,
		blockchainTransactionId.length
	)}`
